import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

async function createGame(params: any) {
  return executeRequest({
    path: "/game/create",
    payload: params,
    method: "post",
  });
}

async function updateGame(gameId: any, params: any) {
  return executeRequest({
    path: `/game/update/${gameId}`,
    payload: params,
    method: "patch",
  });
}

async function getGamesList(params: any) {
  let payload: any = {
    pageNo: params?.pageNo || 1,
    pageSize: params?.pageSize || 25,
    sortDirection: params?.sortDirection || 1,
    sortBy: params?.sortBy || "createdAt",
  };

  if (params?.isActive !== undefined && params?.isActive !== null && params?.isActive !== "") {
    payload["isActive"] = params.isActive;
  }

  if (params?.search) {
    payload["search"] = params.search;
  }

  if (params?.skipPagination) payload["skipPagination"] = true;

  const urlParams = new URLSearchParams(payload).toString();

  return executeRequest({
    path: `/game/list?${urlParams}`,
    method: "get",
  });
}

async function getGameInfo(gameId: any) {
  if (!gameId) throw new Error("No game id provided");

  return executeRequest({
    path: `/game/info/${gameId}`,
    method: "get",
  });
}

export { createGame, updateGame, getGamesList, getGameInfo };
